import React from "react";
import Heros from "../components/Heros";
import AboutUs from "../images/ayushi-contact.jpg";
import Header from "../components/Header";
import Forms from "../components/contact/Forms";
import Footer from "../components/Footer";
import { Helmet } from "react-helmet-async";

function ContactForm() {
  return (
    <>
      <Helmet>
        <title>Contact Us | Ayushi Construction Jabalpur</title>
        <meta
          name="description"
          content="Get in touch with Ayushi Construction in Jabalpur. Visit our office, call our team, or submit an enquiry online. We are here to help you find the right home."
        />
        <meta
          name="keywords"
          content="contact ayushi construction jabalpur, builder contact jabalpur, property enquiry jabalpur"
        />
        <link rel="canonical" href="https://ayushiconstruction.com/contact" />
      </Helmet>

      <Heros title="Contact Us" backgroundImage={AboutUs} />
      <Forms />
    </>
  );
}

export default ContactForm;
